import { Component, OnInit, TemplateRef } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { NotifierService } from 'angular-notifier';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { HeaderService } from 'src/app/core/header/header.service';
import { ErrorHandlerService } from 'src/app/core/services/error-handler.service';
import { XLSValidator } from 'src/app/core/validations/xls-validator';
import { UploadMissedActionDataValidationService } from './upload-missed-action-data-validation.service';
import { DatePipe } from '@angular/common';

@Component({
  selector: 'app-upload-missed-action-data-validation',
  templateUrl: './upload-missed-action-data-validation.component.html',
  styleUrls: ['./upload-missed-action-data-validation.component.scss'],
  providers: [DatePipe]
})
export class UploadMissedActionDataValidationComponent implements OnInit {
  missedActionDataImportFormGroup:UntypedFormGroup;
  isImportFormSubmitted: boolean= false;
  showLoader: boolean= false;
  errorMessage: any = '';
  private readonly notifier: NotifierService;
  workbenchList: any=[];
  bsModalRef!: BsModalRef;
  public maxDate: Date;
  public endDate: Date;
  public missedActionDataID: any = null;
  clientMasterId: any;
  //@ViewChild('importModal') importModal!: TemplateRef<any>; 
 // modalService: any;

  get missedActionDataImportForm() {
    return this.missedActionDataImportFormGroup.controls;
  }
  constructor(private uploadMissedActionDataValidationService: UploadMissedActionDataValidationService,
    private errorHandler: ErrorHandlerService,
    private notifierService: NotifierService,
    private modalService: BsModalService,
    private headerService: HeaderService,
    private formBuilder: UntypedFormBuilder,
    private datePipe: DatePipe) {
      this.notifier = notifierService;
      this.missedActionDataImportFormGroup = new UntypedFormGroup({});
      this.maxDate = new Date();
      this.endDate = new Date();
     }

  ngOnInit(): void {
    this.missedActionDataImportFormGroup = this.formBuilder.group({
      missedActionDataFile: ['', [Validators.required, XLSValidator.validate]],
      missedActionDataFileName: [],
      Value: [''],
      missedActionDataDate: [, [Validators.required]],
      missedActionDataEndDate: [, [Validators.required]],
    });
    this.GetappConfigurationById();
    
  }
  get urlConfigForm() {
    return this.missedActionDataImportFormGroup.controls;
  }

  GetappConfigurationById() {
    this.errorMessage = null;
    this.showLoader = true;
    let data = {
      ID: 86
    }
    this.uploadMissedActionDataValidationService.GetById(data).subscribe({
      next: (data: any) => {
        //this.workbenchImportFormGroup.controls['ConfigId'].setValue(data.Data.ConfigID);
        //this.workbenchImportFormGroup.controls['KeyName'].setValue(data.Data.KeyName);
        this.missedActionDataImportFormGroup.controls['Value'].setValue(data.Data.Value);
        this.showLoader = false;
      }, error: (error: any) => {
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("App Configuration", error.status);
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }
  SetFile(event: any) {
    let file = event.target.files;
    this.missedActionDataImportFormGroup.controls['missedActionDataFile'].setValue(file[0]);
    this.missedActionDataImportFormGroup.controls['missedActionDataFileName'].setValue(file[0].name);
  }

  Import(comfirmation: TemplateRef<any>) {
    console.log('Import Call Success');
    this.isImportFormSubmitted = true;
    if (this.missedActionDataImportFormGroup.invalid) {
      console.log('Import Invalid');
      return;
    }
  
    const file = this.missedActionDataImportFormGroup.controls['missedActionDataFile'].value;
    const clientMasterID = this.headerService.user.ClientMasterID;
    const missedActionDataDate = (this.datePipe.transform(this.missedActionDataImportFormGroup.controls['missedActionDataDate'].value, 'yyyy-MM-dd') ?? '') as string;
    const missedActionDataEndDate = (this.datePipe.transform(this.missedActionDataImportFormGroup.controls['missedActionDataEndDate'].value, 'yyyy-MM-dd') ?? '') as string;
  
    if (!file) {
      console.error('No file selected');
      return;
    }
  
    this.showLoader = true;
    this.uploadMissedActionDataValidationService.uploadFile(file, clientMasterID, missedActionDataDate, missedActionDataEndDate).subscribe({
      next: (data: any) => {
        console.log('callback method', data);
        this.showLoader = false;
        this.clientMasterId = data;
  
        console.log('ErrorViewModel:', data.ErrorViewModel);
  
        if (data.ErrorViewModel) {
          console.log('ErrorViewModel code:', data.ErrorViewModel.Code);
          if (data.ErrorViewModel.Code == 245 || data.ErrorViewModel.Code == 246 || data.ErrorViewModel.Code == 247) {
            this.errorMessage = data.ErrorViewModel.Message;
            this.notifier.notify('error', data.ErrorViewModel.Message);
            return;
          } else if (data.ErrorViewModel.Code == 212) {
            console.log('ErrorMessage:', data.ErrorViewModel.Message);
            if (!data.ErrorViewModel.Message) {
              console.log('!data.ErrorViewModel.Message');
              this.errorMessage = this.errorHandler.GetErrorMessage("Workbench", data.ErrorViewModel.Code)
              this.notifier.notify('error', this.errorMessage);
            } else {
              console.log('Else part !data.ErrorViewModel.Message');
              this.notifier.notify('error', data.ErrorViewModel.Message);
            }
            return;
          } else {
            console.log('else of data.ErrorViewModel.Code == 245 || data.ErrorViewModel.Code == 246');
            this.errorMessage = this.errorHandler.GetErrorMessage("Workbench", data.ErrorViewModel.Code)
            this.notifier.notify('error', this.errorMessage);
            return;
          }
        } else {
          console.log('else data.ErrorViewModel');
          this.bsModalRef = this.modalService.show(comfirmation);
          this.notifier.notify('success', 'Workbench imported successfully.');
          this.ClearImport();
        }
      },
      error: (error: any) => {
        console.log('error from callback method', error);
        this.showLoader = false;
        this.errorMessage = this.errorHandler.GetErrorMessage("Workbench", error.status)
        this.notifier.notify('error', this.errorMessage);
      }
    });
  }

  ClearImport() {
    this.missedActionDataImportFormGroup.reset();
    this.missedActionDataImportFormGroup.controls['missedActionDataFile'].setValidators([Validators.required]);
    this.missedActionDataImportFormGroup.controls['missedActionDataFile'].updateValueAndValidity();
    this.isImportFormSubmitted = false;
    this.errorMessage = '';
    this.bsModalRef.hide();
  }

  Close() {
    this.bsModalRef?.hide()
   // this.router.navigateByUrl("/Workbench");

  }

}
